const scrollTop = () => {
  document.body.scrollTop = 0
  const mainEl = document.body.querySelector('main')
  mainEl ? (mainEl.scrollTop = 0) : null
}

export default scrollTop
